<script setup>
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import ErrorMessages from "../../global/ErrorMessages.vue";
import CustomMultiselect from "@/components/global-themed/CustomMultiselect.vue";
import {computed, ref} from "vue";
import Swal from 'sweetalert2'
import {useStore} from "vuex";

const store = useStore()
const cancellationReason = ref('')
const whatToImprove = ref('')
const cancellationReasons = computed(() => store.getters['agencyCancellation/cancellationReasons'])
const errors = computed(() => store.getters['agencyCancellation/validationErrors'])

const handleCancelled = () => {
  if (cancellationReason.value === 'TECHNICAL_ISSUES') {
    Swal.fire({
      icon: 'warning',
      title: 'We\'re sorry to see you go!',
      text: 'We\'re very sorry you have experienced technical issues with Hike. We may be in '
        + 'touch to learn more so we can improve the platform for everyone moving forwards.',
      confirmButtonText: 'Continue',
      didClose: () => window.location = '/'
    })
    return
  }

  window.location = '/'
}

const submitForm = () => {
  Swal.fire({
    icon: 'warning',
    title: 'Are you sure?',
    text: 'By cancelling your account you will lose all of your current SEO progress!',
    showCancelButton: true,
    confirmButtonColor: '#DD6B55',
    confirmButtonText: 'Yes, Cancel Account!',
    preConfirm: () => store.dispatch('agencyCancellation/submitCancellationForm', {
        cancellationReason: cancellationReason.value,
        whatToImprove: whatToImprove.value,
      }).then(() => {
        Swal.fire({
          icon: 'success',
          title: 'Your plan has been successfully cancelled',
          text: 'If you have no active websites your account will close immediately. Otherwise it will still be accessible until the end of your current billing period.',
          didClose: () => handleCancelled()
        })
      }).catch(() => Swal.close())
  })
}
</script>

<template>
  <div class="tailwind">
    <div class="tw-m-auto tw-max-w-default-container tw-rounded-xl tw-bg-white tw-p-8 tw-text-black">
      <div class="tw-flex tw-flex-col">
        <div class="tw-flex tw-w-3/4 tw-m-auto tw-flex-col tw-gap-2 tw-mb-5 tw-text-lg tw-text-center tw-leading-7 tw-text-slate-200">
          <p>We wanted to personally say thanks for trying our platform. We really wanted you to stick around for the longterm, but we understand you had to cancel your account 😢 </p>
          <p>We have just two quick questions we hope you could answer that would help us improve the platform in the near future…</p>
        </div>

        <div class="tw-w-1/2 tw-m-auto">
          <div class="tw-flex tw-flex-col tw-w-full tw-gap-2 tw-mb-4">
            <label
              for="cancellationReason"
              class="tw-self-center tw-text-lg tw-text-grey-dark"
            >
              What's your reason for cancelling?
            </label>
            <CustomMultiselect
              id="cancellationReason"
              v-model="cancellationReason"
              class="tw-text-left"
              :close-on-select="true"
              :options="cancellationReasons"
              placeholder="Select a cancellation reason"
              :validation-errors="errors.cancellation_reason"
            />
          </div>


          <div class="tw-flex tw-flex-col tw-w-full tw-gap-2">
            <label
              for="cancellationReason"
              class="tw-self-center tw-text-lg tw-text-grey-dark"
            >
              What can we improve?
            </label>
            <textarea
              v-model="whatToImprove"
              class="tw-rounded-lg tw-text-base tw-text-grey-dark tw-px-6 tw-py-3 tw-placeholder-slate-300 tw-border tw-border-grey-mid"
              type="text"
              placeholder="Please let us know anything we can improve on, no matter how small."
              rows="10"
            />

            <ErrorMessages
              v-if="errors?.website"
              class="tw-self-baseline tw-absolute tw-top-12 tw-left-2"
              :errors="errors.website"
            />
          </div>
        </div>

        <div class="tw-w-1/2 tw-m-auto tw-mt-12 tw-flex tw-justify-between">
          <DefaultButton
            class="!tw-w-[189px]"
            @click="store.dispatch('agencyCancellation/previousStep')"
          >
            Go Back
          </DefaultButton>
          <div class="tw-flex tw-gap-3">
            <DefaultButton
              class="!tw-bg-denali"
              variant="primary"
              @click="submitForm"
            >
              Cancel Account
            </DefaultButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
